
// src/actions/organizations.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_ORGANIZATIONS = "FETCH_ORGANIZATIONS"
export const FETCH_ORGANIZATIONS_REQUESTED = "FETCH_ORGANIZATIONS_REQUESTED"
export const FETCH_ORGANIZATIONS_COMPLETED = "FETCH_ORGANIZATIONS_COMPLETED"
export const FETCH_ORGANIZATIONS_FAILED = "FETCH_ORGANIZATIONS_FAILED"

export function fetchOrganizationsRequested() {
  return {
    type: FETCH_ORGANIZATIONS_REQUESTED
  }
}

export function fetchOrganizations() {
  return function(dispatch) {
    dispatch(fetchOrganizationsRequested())
    return api.get(`/organizations`)
        .then((results)=> {
          dispatch(fetchOrganizationsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchOrganizationsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchOrganizationsCompleted(results) {
  return {
    type: FETCH_ORGANIZATIONS_COMPLETED,
    results,
  }
}

export function fetchOrganizationsFailed(error) {
  return {
    type: FETCH_ORGANIZATIONS_FAILED,
    error,
  }
}

export const FETCH_ORGANIZATION = "FETCH_ORGANIZATION"
export const FETCH_ORGANIZATION_REQUESTED = "FETCH_ORGANIZATION_REQUESTED"
export const FETCH_ORGANIZATION_COMPLETED = "FETCH_ORGANIZATION_COMPLETED"
export const FETCH_ORGANIZATION_FAILED = "FETCH_ORGANIZATION_FAILED"

export function fetchOrganizationRequested() {
  return {
    type: FETCH_ORGANIZATION_REQUESTED
  }
}

export function fetchOrganization(organization_id) {
  return function(dispatch) {
    dispatch(fetchOrganizationRequested())
    return api.get(`/organizations/${organization_id}`)
        .then((results)=> {
          dispatch(fetchOrganizationCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchOrganizationFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchOrganizationCompleted(results) {
  return {
    type: FETCH_ORGANIZATION_COMPLETED,
    results,
  }
}

export function fetchOrganizationFailed(error) {
  return {
    type: FETCH_ORGANIZATION_FAILED,
    error,
  }
}

export const FETCH_ORGANIZATION_MEMBERS = "FETCH_ORGANIZATION_MEMBERS"
export const FETCH_ORGANIZATION_MEMBERS_REQUESTED = "FETCH_ORGANIZATION_MEMBERS_REQUESTED"
export const FETCH_ORGANIZATION_MEMBERS_COMPLETED = "FETCH_ORGANIZATION_MEMBERS_COMPLETED"
export const FETCH_ORGANIZATION_MEMBERS_FAILED = "FETCH_ORGANIZATION_MEMBERS_FAILED"

export function fetchOrganizationMembersRequested() {
  return {
    type: FETCH_ORGANIZATION_MEMBERS_REQUESTED
  }
}

export function fetchOrganizationMembers(organization_id) {
  return function(dispatch) {
    dispatch(fetchOrganizationMembersRequested())
    return api.get(`/organizations/${organization_id}/members`)
        .then((results)=> {
          dispatch(fetchOrganizationMembersCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchOrganizationMembersFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchOrganizationMembersCompleted(results) {
  return {
    type: FETCH_ORGANIZATION_MEMBERS_COMPLETED,
    results,
  }
}

export function fetchOrganizationMembersFailed(error) {
  return {
    type: FETCH_ORGANIZATION_MEMBERS_FAILED,
    error,
  }
}

export const UPDATE_ORGANIZATION_MEMBERSHIP = "UPDATE_ORGANIZATION_MEMBERSHIP"
export const UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED = "UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED"
export const UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED = "UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED"
export const UPDATE_ORGANIZATION_MEMBERSHIP_FAILED = "UPDATE_ORGANIZATION_MEMBERSHIP_FAILED"

export function updateOrganizationMembershipRequested() {
  return {
    type: UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED
  }
}

export function updateOrganizationMembership(organization_id, user_id, role) {
  return function(dispatch) {
    dispatch(updateOrganizationMembershipRequested())
    return api.put(`/organizations/${organization_id}/members/${user_id}`, { role })
        .then((results)=> {
          dispatch(updateOrganizationMembershipCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateOrganizationMembershipFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateOrganizationMembershipCompleted(results) {
  return {
    type: UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED,
    results,
  }
}

export function updateOrganizationMembershipFailed(error) {
  return {
    type: UPDATE_ORGANIZATION_MEMBERSHIP_FAILED,
    error,
  }
}

export const FETCH_ORGANIZATION_GROUPS = "FETCH_ORGANIZATION_GROUPS"
export const FETCH_ORGANIZATION_GROUPS_REQUESTED = "FETCH_ORGANIZATION_GROUPS_REQUESTED"
export const FETCH_ORGANIZATION_GROUPS_COMPLETED = "FETCH_ORGANIZATION_GROUPS_COMPLETED"
export const FETCH_ORGANIZATION_GROUPS_FAILED = "FETCH_ORGANIZATION_GROUPS_FAILED"

export function fetchOrganizationGroupsRequested() {
  return {
    type: FETCH_ORGANIZATION_GROUPS_REQUESTED
  }
}

export function fetchOrganizationGroups(organization_id) {
  return function(dispatch) {
    dispatch(fetchOrganizationGroupsRequested())
    return api.get(`/organizations/${organization_id}/groups`)
        .then((results)=> {
          dispatch(fetchOrganizationGroupsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchOrganizationGroupsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchOrganizationGroupsCompleted(results) {
  return {
    type: FETCH_ORGANIZATION_GROUPS_COMPLETED,
    results,
  }
}

export function fetchOrganizationGroupsFailed(error) {
  return {
    type: FETCH_ORGANIZATION_GROUPS_FAILED,
    error,
  }
}




// WEBPACK FOOTER //
// ./src/actions/organizations.js